<template>
    <v-content class="loginContent">
        <v-container class="fill-height"
                     fluid>
            <v-row align="center"
                   justify="center">
                <v-col cols="12"
                       sm="8"
                       md="4">
                    <v-card class="elevation-12">
                        <v-toolbar color="#213B87"
                                   dark
                                   flat>
                            <v-toolbar-title>
                                    <img src="https://grupowapps.es/images/png/logo/logo.png" width="175" alt="grupowapps">
                            </v-toolbar-title>
                            <v-spacer/>
                        </v-toolbar>
                        <v-card-text>
                            <v-alert class="emptyAlert" v-if="emptyError" type="error">
                                Por favor, rellena todos los campos
                            </v-alert>
                            <v-alert class="emptyAlert" v-if="notFoundError" type="error">
                                E-Mail/Contraseña no existentes
                            </v-alert>
                            <v-alert class="emptyAlert" v-if="apiError" type="error">
                                Ha habido un error, por favor, inténtalo de nuevo más tarde
                            </v-alert>
                            <v-form @keyup.enter.native="submit">
                                <v-text-field
                                        label="Usuario"
                                        name="login"
                                        v-model="email"
                                        prepend-icon="mdi-account"
                                        type="text"/>
                                <v-text-field
                                        v-model="password"
                                        id="password"
                                        label="Password"
                                        name="password"
                                        prepend-icon="mdi-lock"
                                        type="password"/>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn color="#213B87" dark class="loginBT" :loading="loading" v-on:click="submit">Login</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>
    export default {
        name: "login",
        data() {
            return {
                loading:false,
                emptyError: false,
                apiError:false,
                notFoundError: false,
                email: '',
                password: ''
            }
        },
        mounted() {
            this.checkSession()
        },
        methods: {
            checkSession(){
                this.logged = localStorage.token != null;
                if (!this.logged) this.$router.push('/login');
            },
            signOut() {
                localStorage.clear();
                location.reload();
            },
            submit(){
                this.loading = true;
                if(this.email === '' || this.password === ''){
                    this.emptyError = true;
                    this.loading = false;
                }else{
                    this.emptyError = false;
                    let url = this.base_url+'/invV2/admin/login';
                    let formData = new FormData();
                    formData.set('user', this.email);
                    formData.set('pass', this.password);
                    this.axios.post(url,formData).then(response => {
                        localStorage.token = response.data.token;
                        this.$router.push('/');
                        location.reload();
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        if (error.response.status === 404){
                            this.notFoundError = true;
                            this.apiError = false;
                        }
                        else{
                            this.notFoundError=false;
                            this.apiError = true;
                        }
                    })
                }
            }
        }
    };
</script>
<style>
    .loginBT{
        font-size: 12pt !important;
        margin: 0 0.5em 0 0.5em;
        padding: 0.6em !important;
    }
    .emptyAlert{
        background: #9D130B !important;
    }
</style>
